const initGlobalState = {
    lang: 'en',
    isLogin: false,
    name: '',
    phone: '',
};

const globalReducer = (state = initGlobalState, action) => {
    if (action.type === 'SET_LANG') {
        return {
            ...state,
            lang: action.lang,
        }
    }
    
    if (action.type === 'SET_IS_LOGIN') {
        return {
            ...state,
            isLogin: action.isLogin,
        }
    }


    if (action.type === 'SET_NAME') {
        return {
            ...state,
            name: action.name,
        }
    }


    if (action.type === 'SET_PHONE') {
        return {
            ...state,
            phone: action.phone,
        }
    }


    return state;
};

export default globalReducer;
